import { isWithinRange } from 'date-fns'
import { DateTime } from 'luxon'
import groups from '@/data/groupList'
import legs from '@/data/legList'

// Luxon's time zone override support is needed for this function. This is to
// stop js default behavior of forcing every date to be in the specific
// user's timezone. We want eveything to be done in EST

let groupLegIdentification = function (currentDate) {
    let result = {
        group: 0,
        leg: 0
    }

    for (let x = 0; x < groups.length; x++) {
        let groupResult = isWithinRange(
            new Date(currentDate),
            DateTime.fromISO(groups[x].startDate, { zone: 'America/New_York' }),
            DateTime.fromISO(groups[x].endDate, { zone: 'America/New_York' })
        )

        if (groupResult) {
            result.group = groups[x].group
        }
    }

    for (let x = 0; x < legs.length; x++) {
        let legResult = isWithinRange(
            new Date(currentDate),
            DateTime.fromISO(legs[x].startDate, { zone: 'America/New_York' }),
            DateTime.fromISO(legs[x].endDate, { zone: 'America/New_York' })
        )

        if (legResult) {
            result.leg = legs[x].leg
        }
    }

    return result
}

export default groupLegIdentification



// WEBPACK FOOTER //
// ./src/common/groupLegIdentification.js